import React from 'react';
import styled from 'styled-components';
import { MobilePopupBottom } from '@lt/components';
import { useTranslation } from '@lt/localization';
import ClientSummary from './components/ClientSummary';
import HotelSummary from './components/HotelSummary';
import PriceSummary from './components/PriceSummary';
import TouristsSummary from './components/TouristsSummary';
import type { HotelOnlyProps } from './types';

const MobileSummaryHotels = ({
  totalPrice,
  instantConfirm,
  cashbackAmount,
  packageId,
  priceDetailsItems,
  cashbackIdentifier,

  hotel,
  dates,
  onHotelClick,
  touristsText,

  client,
  onClientClick,

  tourists,
  onTouristClick,
  isTouristsConfirmed,

  visible,
  onClose,
}: HotelOnlyProps) => {
  const priceSummaryProps = {
    totalPrice,
    instantConfirm,
    cashbackAmount,
    packageId,
    priceDetailsItems,
    cashbackIdentifier,
  };

  const hotelSummaryProps = {
    hotel,
    dates,
    onClick: () => onHotelClick(packageId),
    touristsText,
  };

  const clientSummaryProps = {
    client,
    onClick: onClientClick,
  };

  const touristsSummaryProps = {
    tourists,
    onClick: onTouristClick,
    isTouristsConfirmed,
  };

  const { t } = useTranslation();

  return (
    <StyledBottomPopup
      visible={visible}
      onClick={onClose}
      options={{ showCloseIcon: true }}
    >
      <Title>{t('checkout.summary.title')}</Title>
      <Wrapper>
        <PriceSummary {...priceSummaryProps} />
        <Divider />
        <HotelSummary isHotelOnly {...hotelSummaryProps} />
        <Divider />
        <ClientSummary {...clientSummaryProps} />
        <Divider />
        <TouristsSummary {...touristsSummaryProps} />
      </Wrapper>
    </StyledBottomPopup>
  );
};

const StyledBottomPopup = styled(MobilePopupBottom)`
  padding: 8px 0 0;
`;

const Title = styled.div`
  color: #17181a;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  margin: 0 0 8px 8px;
`;

const Wrapper = styled.div`
  overflow-x: auto;
`;

const Divider = styled.hr`
  border: none;
  width: 100%;
  height: 1px;
  background-color: #e6e9ee;
`;

export default MobileSummaryHotels;
